import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background-color: ${tokens.colors.white};
  position: fixed;
  top: 0;
  z-index: 12;
`
